import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import { ISetRecentProductsAction } from "../interfaces/utils.interface";
export function setRecentProducts(recentProducts: ICompactProduct[]): ISetRecentProductsAction {
  return {
    type: "RECENT_PRODUCTS",
    data: recentProducts,
  };
}
